import {Menu, styled} from "@mui/material";

export const BarekamMenu = styled(Menu)(() => ({
    '& .MuiPaper-root': {
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.20)',
        shadowBlur: 4,
        shadowOffsetY: 4
    }
}));